module.exports = __webpack_public_path__ + "img/correct-large.b2e46e73.png";